import * as Common from '@/tenant/common';

export class Category extends Common.MasterBase{
  constructor(){
    super('Category');
    this.state = Common.MasterBaseStatus.NotPosted;
    this.workflowStateId = Common.MasterBaseStatus.NotPosted;
  }
  public categoryType: number = 0;
  public code: string = '';
  public name: string='';
  public id: number = 0;
  public copy():any {
    const temp = super.copy() as Category;
    temp.code = null;    
    temp.state = Common.MasterBaseStatus.NotPosted;
    temp.workflowStateId = Common.MasterBaseStatus.NotPosted;
    temp.id = 0;
    return temp;
  }
}

export enum CategoryTypes {
  CounterpartCategory1 = 1,
  CounterpartCategory2 = 2,
  CounterpartCategory3 = 3,
  CounterpartCategory4 = 4,
  CounterpartCategory5 = 5,
  CounterpartCategory6 = 6,
  CommodityCategory1 = 11,
  CommodityCategory2 = 12,
  CommodityCategory3 = 13,
  CommodityCategory4 = 14,
  CommodityCategory5 = 15,
  CommodityCategory6 = 16,
  SegmentCategory1 = 21,
  SegmentCategory2 = 22,
  SegmentCategory3 = 23,
  SegmentCategory4 = 24,
  SegmentCategory5 = 25,
  SegmentCategory6 = 26,
  ReserveCustomer1 = 31,
  ReserveCustomer2 = 32,
  ReserveCustomer3 = 33,
  ReserveCommodity1 = 41,
  ReserveCommodity2 = 42,
  ReserveCommodity3 = 43,
  CommodityPriceCategory = 101,
  // ForwarderCategory = 111,
  // ArrivalHourCategory = 112,
}


export class CategoryQuery extends Common.LoadQuery {
  constructor(){
    super('CategoryQuery',Category);
    this.sort = 'code';
  }

  public categoryType: CategoryTypes = null;
  public code: string = '';
  public name: string = '';
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.MasterBaseStatus = null;
  public holder: string = '';
  public auditNo: string ='';
}

export enum CategoryGroup {
  All = 0,
  Counterpart = 1,
  Commodity = 2
}

export class CategoryMasterQuery extends Common.LoadQuery {
  constructor(categoryGroup: CategoryGroup) {
    super('CategoryMasterQuery', Category);
    this.categoryGroup = categoryGroup;
  }
  public categoryGroup: CategoryGroup = CategoryGroup.All;
}